module.exports = __webpack_public_path__ + "img/campus_recruitment.c0fb80f.png";